import { useParams, Navigate } from 'react-router'
import dayjs from 'dayjs'
import { useFormConfirmed } from 'shared/hooks/useFormConfirmed'
import { useLoansListRevalidate } from 'modules/pools/hooks/useLoansList'

import { FormRepayment, SuccessData } from 'modules/pools/ui/FormRepayment'
import { SentTransaction } from 'modules/pools/ui/SentTransaction'
import { NarrowWrapper } from 'shared/ui/layout/NarrowWrapper'
import { PageLoader } from 'shared/ui/layout/PageLoader'

import { ContractRociPayment } from 'modules/contracts/contracts'
import { createRoute } from 'modules/router/utils/createRoute'
import { isLoanActive } from 'modules/pools/utils/isLoanActive'
import { RoundCTAButton } from 'shared/ui/controls/RoundCTAButton'
import { Text } from 'shared/ui/common/Text'
import { borrow } from 'modules/router/links'

import { ReactComponent as BorrowIcon } from 'assets/borrow.svg'

import s from './RouteRepayment.module.scss'

function RouteRepayment() {
  const { loanId = '' } = useParams()
  const { pathname, isConfirmed, successData, confirmForm } =
    useFormConfirmed<SuccessData>()

  const { isLoading, data: loan } = ContractRociPayment.useSwrRpc(
    'loanLookup',
    [loanId],
  )

  const revalidateLoans = useLoansListRevalidate()

  if (isLoading || !loan) {
    return <PageLoader />
  }

  if (isConfirmed) {
    if (!successData) return <Navigate replace to={pathname} />

    const isRepaidOnTime = dayjs().isBefore(dayjs().add(35, 'days'))

    return (
      <SentTransaction
        transactionType="Repayment"
        txHash={successData.tx.hash}
        amountToDisplay={successData.formValues.amount}
        amountToken={successData.formValues.borrowedAsset}
        warning={
          isRepaidOnTime && (
            <RoundCTAButton
              size={296}
              borderOffset={44}
              href={borrow}
              isExternal={false}
              fashion="purple"
              icon={<BorrowIcon />}
              className={s.cta}
              testId="repayment-borrow-again-button"
            >
              <Text size={16} weight={600} isUppercased className={s.ctaText}>
                Take new <br /> loan with <br /> Rocifi
              </Text>
            </RoundCTAButton>
          )
        }
        onSuccess={revalidateLoans}
      />
    )
  }

  if (!isLoanActive(loan)) {
    return null
  }

  return (
    <NarrowWrapper>
      <FormRepayment
        loan={loan}
        loanId={loanId}
        // investorAddress={investorAddress}
        onSuccess={confirmForm}
      />
    </NarrowWrapper>
  )
}

export const routeRepayment = createRoute({
  headerTitle: 'Repayment',
  layoutType: 'narrow-extended',
  component: RouteRepayment,
  checkConnect: true,
})
